// 루트
export const ROUTE_ROOT = '/';

// 회원가입
export const ROUTE_SIGN_UP = '/sign-up';

// 로그인
export const ROUTE_SIGN_IN = '/sign-in';

// 공지
export const ROUTE_NOTICE = '/notice';

// pjt
export const ROUTE_PJT = '/pjt';

// company
export const ROUTE_COMPANY = '/company';

// user
export const ROUTE_USER = '/user';
export const ROUTE_USER_APPROVAL = `${ROUTE_USER}/user-approval`;
export const ROUTE_USER_ADMINISTRATOR_MANAGEMENT = `${ROUTE_USER}/administrator-management`;
export const ROUTE_USER_WORKER_MANAGEMENT = `${ROUTE_USER}/worker-management`;
export const ROUTE_USER_FRS_MANAGEMENT = `${ROUTE_USER}/frs-management`;

//passport
export const ROUTE_PASSPORT = '/passport';
export const ROUTE_PASSPORT_SITE_ENTRY_MANAGEMENT = `${ROUTE_PASSPORT}/site-entry-management`;
export const ROUTE_PASSPORT_SAFETY_TRAINING = `${ROUTE_PASSPORT}/safety-training`;
export const ROUTE_PASSPORT_TRAINING_SETTING = `${ROUTE_PASSPORT}/training-setting`;
export const ROUTE_PASSPORT_SITE_ENTRY_HISTORY = `${ROUTE_PASSPORT}/site-entry-history`;

// Environment (Weather & Air Quality Monitoring)
export const ROUTE_ENVIRONMENT = '/environment';
export const ROUTE_ENVIRONMENT_CURRENT = `${ROUTE_ENVIRONMENT}/current`;
export const ROUTE_ENVIRONMENT_HISTORTY = `${ROUTE_ENVIRONMENT}/history`;

// 대시보드
export const ROUTE_DASHBOARD = '/dashboard';
export const ROUTE_CHART_DASHBOARD = `${ROUTE_DASHBOARD}/chart`;
export const ROUTE_3D_DASHBOARD = `${ROUTE_DASHBOARD}/3d`;

// system
export const ROUTE_SYSTEM = '/system';

// TBM - tool box meeting
export const ROUTE_TBM = '/tbm';
export const ROUTE_TBM_STATUS = `${ROUTE_TBM}/status`;
export const ROUTE_TBM_ATTENDANCE = `${ROUTE_TBM}/attendance`;
export const ROUTE_TBM_MONITORING = `${ROUTE_TBM}/monitoring`;

// Heavy Equipment
export const ROUTE_HEAVY_EQUIPMENT = '/heavy-equipment';
export const ROUTE_HEAVY_EQUIPMENT_MANAGEMENT = `${ROUTE_HEAVY_EQUIPMENT}/management`;
export const ROUTE_HEAVY_EQUIPMENT_MY = `${ROUTE_HEAVY_EQUIPMENT}/my`;
export const ROUTE_HEAVY_EQUIPMENT_STATUS = `${ROUTE_HEAVY_EQUIPMENT}/status`;
export const ROUTE_HEAVY_EQUIPMENT_SETTING = `${ROUTE_HEAVY_EQUIPMENT}/setting`;
export const ROUTE_HEAVY_EQUIPMENT_HISTORY = `${ROUTE_HEAVY_EQUIPMENT}/history`;

// Smart Device (PKG2 - GS 전용)
const ROUTE_SMART_DEVICE = '/smart-device';
export const ROUTE_SMART_DEVICE_MANAGEMENT = `${ROUTE_SMART_DEVICE}/management`;
export const ROUTE_SMART_DEVICE_DISTRIBUTION = `${ROUTE_SMART_DEVICE}/distribution`;
export const ROUTE_SMART_DEVICE_ALERT_HISTORY = `${ROUTE_SMART_DEVICE}/alert-history`;

// M-PTW
export const ROUTE_PTW = '/ptw';
export const ROUTE_PTW_MY_ISSUE = `${ROUTE_PTW}/my-issue`;
export const ROUTE_PTW_MY_APPROVAL = `${ROUTE_PTW}/my-approval`;
export const ROUTE_PTW_STATUS = `${ROUTE_PTW}/status`;
export const ROUTE_PTW_SETTING = `${ROUTE_PTW}/setting`;

//IOT
export const ROUTE_IOT = '/iot';
export const ROUTE_IOT_DEVICE = `${ROUTE_IOT}/iot-device`;
export const ROUTE_IOT_DISTRIBUTE = `${ROUTE_IOT}/iot-distribute`;
export const ROUTE_IOT_ENV_SENSOR = `${ROUTE_IOT}/env-sensor`;
export const ROUTE_IOT_ALTER_HISTORY = `${ROUTE_IOT}/alert-history`;

//HEAVY Equipment
export const ROUTE_HEAVY = '/heavy';
export const ROUTE_HEAVY_MANAGEMENT = `${ROUTE_HEAVY}/manage`;
export const ROUTE_HEAVY_APPROVAL = `${ROUTE_HEAVY}/approval`;
export const ROUTE_HEAVY_SETTING = `${ROUTE_HEAVY}/setting`;

// TBM Management (standalone)
export const ROUTE_TBM_MANAGEMENT = '/tbm-management';

//WEATHER AIR QUALITY
export const ROUTE_WEATHER = '/weather';
export const ROUTE_WEATHER_TODAY_WEATHER = `${ROUTE_WEATHER}/today-weather`;
export const ROUTE_WEATHER_WEATHER_HISTORY = `${ROUTE_WEATHER}/weather-history`;

// MDM
export const ROUTE_MDM = '/pmdm';
export const ROUTE_MDM_DEVICES = `${ROUTE_MDM}/devices`;
